/**
 * Component is used to track purchase analytics
 *
 *
 * HTML Structure Example
 *
 * <e2-purchase-analytics-tracker></e2-purchase-analytics-tracker>
 */

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/order';
import { actions as analyticsActions } from '@elab/core/store/analytics';
import analytics from '@elab/core/utils/analytics';
import isEmpty from '@elab/core/utils/isEmpty';
import { selectors as userSelectors } from '@elab/core/store/user';

export class PurchaseAnalyticsTracker extends SimpleLitElement {
    static get properties() {
        return {
            order: {
                type: Object,
                attribute: false,
            },
            isLoyalty: { type: Boolean, attribute: false },
            transactionTracked: { type: Boolean, attribute: false },
            waitForPageLoad: { type: Boolean, attribute: 'wait-for-page-load' },
        };
    }

    constructor() {
        super();
        this.transactionTracked = false;
        this.waitForPageLoad = false;
    }

    updated(changedProperties) {
        super.updated(changedProperties);
        if (!isEmpty(this.order) && !this.transactionTracked) {
            this.transactionTracked = true;
            if (this.waitForPageLoad) {
                this.dispatchEvent(
                    new CustomEvent('SEND_TRANSACTION_WAITING', { detail: this.order }),
                );
            } else {
                analytics.handleTransaction({ ...this.order, isLoyalty: this.isLoyalty });
            }
        }
    }
}

const mapStateToProps = state => ({
    isLoyalty: userSelectors.isLoyalty(state),
    order: selectors.getOrderData(state),
});

const mapDispatchToEvents = dispatch => ({
    SEND_TRANSACTION_WAITING: ({ detail }) =>
        dispatch(analyticsActions.sendTransactionWaiting(detail)),
});

export default () =>
    customElements.define(
        'e2-purchase-analytics-tracker',
        connect(mapStateToProps, mapDispatchToEvents)(PurchaseAnalyticsTracker),
    );
